import { Chip, MetricCard, MetricStrip } from '@/components/ui'
import { useWorkersHealth } from '../api/queries'

export function SystemHealthSection() {
  const { data, isLoading, dataUpdatedAt } = useWorkersHealth()

  const broker = data?.broker ?? 'unreachable'
  const workers = data?.workers ?? 0
  const overall = data?.status ?? 'unhealthy'

  const updatedLabel = dataUpdatedAt
    ? new Date(dataUpdatedAt).toLocaleTimeString()
    : '—'

  return (
    <section className="flex flex-col gap-4">
      <header>
        <h2 className="text-lg font-semibold text-primary">System Health</h2>
        <p className="text-sm text-secondary">
          Live middleware + worker status. Polls every 30 seconds.
        </p>
      </header>

      <MetricStrip>
        <MetricCard
          label="Overall"
          value={overall.toUpperCase()}
          valueTone={
            overall === 'healthy'
              ? 'success'
              : isLoading
                ? 'default'
                : 'danger'
          }
        />
        <MetricCard
          label="Broker"
          value={broker}
          valueTone={broker === 'ok' ? 'success' : 'danger'}
        />
        <MetricCard
          label="Workers"
          value={workers.toLocaleString()}
          valueTone={workers > 0 ? 'success' : 'danger'}
        />
        <MetricCard label="Last check" value={updatedLabel} />
      </MetricStrip>

      <section className="flex flex-col gap-2 rounded-sm border border-border-subtle bg-surface p-4">
        <h3 className="text-sm font-semibold text-primary">What this checks</h3>
        <ul className="flex flex-col gap-1 text-sm text-secondary">
          <li className="flex items-center gap-2">
            <Chip size="xs" variant="info">
              /health/workers
            </Chip>
            Broker connectivity + Celery worker count, returned by the
            middleware health endpoint.
          </li>
          <li className="flex items-center gap-2">
            <Chip size="xs" variant="neutral">
              Future
            </Chip>
            Queue depth, last webhook timestamp, last Odoo sync — waiting on
            middleware endpoints.
          </li>
        </ul>
      </section>
    </section>
  )
}
